import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import desktoplogo from "../../../assets/media/photos/inner-logo.png";
import mobilelogo from "../../../assets/media/photos/inner-logo-icon.png";
import Footer from "../Footer";
import {
  ChevronDown,
  User,
  Settings,
  Home,
  Building2,
  Clock,
  Briefcase,
  Activity,
  Map,
  MapPinned,
  BarChart3
} from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { fetchData } from "../../../utils/functions";

const MobileSideBar = ({ visible }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isSidebarHovered, setIsSidebarHovered] = useState(false);
  const [activeItem, setActiveItem] = useState(() => {
    return sessionStorage.getItem("activeItem");
  });
  const [activeChild, setActiveChild] = useState(() => {
    return sessionStorage.getItem("activeChild");
  });

  const loading = useSelector((state) => state);
  const userRole = loading?.auth?.user?.user_role_name || "";
  const isSuperAdmin = userRole === "Super Admin";
  const permission = loading?.auth?.user?.user_permissions || [];

  const dashboardPermissions = [
    ...(permission.includes("dashboard-household")
      ? [{ label: "Dashboard", link: "/" }]
      : []),
    ...(permission.includes("dashboard-wash")
      ? [{ label: "Dashboard", link: "/" }]
      : []),
    ...(permission.includes("dashboard-business-grant-sme")
      ? [{ label: "Dashboard", link: "/" }]
      : []),
    ...(permission.includes("dashboard-business-grant-micro")
      ? [{ label: "Dashboard", link: "/" }]
      : []),
    ...(permission.includes("dashboard-school")
      ? [{ label: "Dashboard", link: "/" }]
      : []),
    ...(permission.includes("dashboard-health-facility")
      ? [{ label: "Dashboard", link: "/" }]
      : []),
    ...(["dashboard-boq", "dashboard-boq-implementation", "dashboard-boq-monitoring"].some((p) =>
      permission.includes(p)
    )
      ? [{ label: "Dashboard", link: "/" }]
      : []),
  ];
  const userManagementOptions = [
    ...(permission.includes("permission-view")
      ? [{ label: "Manage Permissions", link: "/Manage-permissions" }]
      : []),
    ...(permission.includes("group-view")
      ? [{ label: "Manage Groups", link: "/groups" }]
      : []),
    ...(permission.includes("role-view")
      ? [{ label: "Manage Roles", link: "/roles" }]
      : []),
    ...(permission.includes("user-view")
      ? [{ label: "Manage User", link: "/users" }]
      : []),
  ];

  const metadataOptions = [
    ...(permission.includes("district-view")
      ? [{ label: "District", link: "/districts" }]
      : []),
    ...(permission.includes("rgc-view")
      ? [{ label: "RGC", link: "/rgcs" }]
      : []),
    ...(permission.includes("tehsil-view")
      ? [{ label: "Tehsil", link: "/tehsils" }]
      : []),
    ...(permission.includes("ucs-view")
      ? [{ label: "Union Council", link: "/ucs" }]
      : []),
    ...(permission.includes("deh-view")
      ? [{ label: "Deh", link: "/dehs" }]
      : []),
    ...(permission.includes("village-view")
      ? [{ label: "Village", link: "/villages" }]
      : []),
    ...(permission.includes("location-view")
      ? [{ label: "Location", link: "/locations" }]
      : []),
    ...(permission.includes("levelManagement-view")
      ? [{ label: "Level", link: "/levels" }]
      : []),
    ...(permission.includes("Management-view")
      ? [{ label: "Management", link: "/management" }]
      : []),
    ...(permission.includes("class-view")
      ? [{ label: "Class", link: "/class" }]
      : []),
    ...(permission.includes("gender-view")
      ? [{ label: "Gender", link: "/gender" }]
      : []),
    ...(permission.includes("feature-view")
      ? [{ label: "Features", link: "/features" }]
      : []),
    ...(permission.includes("feature-sub-type-view")
      ? [{ label: "Feature Sub Type", link: "/subtypes" }]
      : []),
    ...(permission.includes("feature-category-view")
      ? [{ label: "Feature Category", link: "/feature-category-view" }]
      : []),
    ...(permission.includes("cycle-view")
      ? [{ label: "Cycle", link: "/cycles" }]
      : []),
    ...(permission.includes("mpi-standard-view")
      ? [{ label: "MPI Standard", link: "/mpi-standard" }]
      : []),
  ];

  const planningPhaseOptions = [
    ...(permission.includes("household-information-view")
      ? [{ label: "Household Information", link: "/household" }]
      : []),
    ...(permission.includes("wash-information-view")
      ? [{ label: "Wash Information", link: "/wash" }]
      : []),
    ...(permission.includes("school-assessment-view")
      ? [{ label: "School Assessment", link: "/schoolassessment" }]
      : []),
    ...(permission.includes("health-facility-assessment-view")
      ? [{ label: "Health Facility", link: "/healthfacilityassessment" }]
      : []),
    ...(permission.includes("infrastructure-information-view")
      ? [
          {
            label: "Proposed Feature | Infrastructure",
            link: "/proposed-features",
          },
        ]
      : []),
  ];

  const SMEPhaseOptions = [
    ...(permission.includes("sme-grant-view")
      ? [{ label: "SME Grant", link: "/sme-grant" }]
      : []),
    ...(permission.includes("corporate-grant-view")
      ? [{ label: "Corporate Grant", link: "/corporate-grant" }]
      : []),
    ...(permission.includes("social-enterprise-grant-view")
      ? [{ label: "Social Enterprise Grant", link: "/social-enterprise-grant" }]
      : []),
    ...(permission.includes("sedf-enterprise-grant-view")
      ? [{ label: "SEDF Enterprise Grant", link: "/sedf-enterprise-grant" }]
      : []),
    ...(permission.includes("micro-grant-view")
      ? [{ label: "Micro Grant", link: "/micro-grant" }]
      : []),
    ...(permission.includes("grants-attachment-view")
      ? [{ label: "Useful Attachments", link: "/useful-attachments" }]
      : []),
  ];
  const ImplemenationPhase = [
    ...(permission.includes("implementation-phase-view")
      ? [{ label: "Implementation Phase", link: "/implementation-phase" }]
      : []),
  ];
  const MonitoringPhase = [
    ...(permission.includes("monitoring-phase-view")
      ? [{ label: "Monitoring Phase", link: "/monitoring-phase" }]
      : []),
  ];

  const GISPhase = [
    ...(permission.includes("gis-view")
      ? [
          {
            id: "gis",
            label: "GIS Dashboard",
            icon: MapPinned,
            isExternal: true,
          },
        ]
      : []),
  ];

  const menuItems = [
    ...(dashboardPermissions.length > 0
      ? [
          {
            id: "dashboard",
            label: "Dashboard",
            link: "/",
            icon: Home,
            isDropdown: false,
          },
        ]
      : []),

    ...(GISPhase.length > 0
      ? [
          {
            id: "gis",
            label: "GIS Dashboard",
            icon: MapPinned,
            isDropdown: false,
            isExternal: true,
          },
        ]
      : []),

    ...(userManagementOptions.length > 0
      ? [
          {
            id: "userManagement",
            label: "User Management",
            icon: User,
            isDropdown: true,
            options: userManagementOptions,
          },
        ]
      : []),
    ...(isSuperAdmin || metadataOptions.length > 0
      ? [
          {
            id: "lookup",
            label: "Lookup",
            icon: Settings,
            isDropdown: true,
            options: metadataOptions,
          },
        ]
      : []),
    ...(planningPhaseOptions.length > 0
      ? [
          {
            id: "planningPhase",
            label: "Planning Phase",
            icon: Clock,
            isDropdown: true,
            options: planningPhaseOptions,
          },
        ]
      : []),

    ...(ImplemenationPhase.length > 0
      ? [
          {
            id: "implementationphase",
            label: "Implementation Phase",
            link: "/implementation-phase",
            icon: Building2,
            isDropdown: false,
          },
        ]
      : []),

    ...(MonitoringPhase.length > 0
      ? [
          {
            id: "monitoringphase",
            label: "Monitoring Phase",
            link: "/monitoring-phase",
            icon: Activity,
            isDropdown: false,
          },
        ]
      : []),

    ...(SMEPhaseOptions.length > 0
      ? [
          {
            id: "SMEPhase",
            label: "Business Grants",
            icon: Briefcase,
            isDropdown: true,
            options: SMEPhaseOptions,
          },
        ]
      : []),

    ...(permission.includes("mpi-household-view") ||
    permission.includes("mpi-village-view")
      ? [
          {
            id: "mpi",
            label: "MPI",
            icon: BarChart3,
            isDropdown: true,
            options: [
              ...(permission.includes("mpi-household-view")
                ? [{ label: "MPI Household", link: "/mpi-household" }]
                : []),
              ...(permission.includes("mpi-village-view")
                ? [{ label: "MPI Village", link: "/mpi-village" }]
                : []),
            ],
          },
        ]
      : []),
  ];

  useEffect(() => {
    sessionStorage.setItem("activeItem", activeItem);
    sessionStorage.setItem("activeChild", activeChild);
    sessionStorage.setItem("openDropdown", openDropdown);
  }, [activeItem, activeChild, openDropdown]);

  useEffect(() => {
    const currentPath = location.pathname;
    for (const item of menuItems) {
      if (item.link === currentPath) {
        setActiveItem(item.id);
        setOpenDropdown(null);
        setActiveChild(null);
        return;
      }
      if (item.options) {
        for (const option of item.options) {
          if (option.link === currentPath) {
            setActiveItem(item.id);
            setOpenDropdown(item.id);
            setActiveChild(option.link);
            return;
          }
        }
      }
    }
  }, [location.pathname]);

  const openGisDashboard = async () => {
    // opened before the request, because browsers block pop-ups opened after an await
    const gisWindow = window.open("", "_blank");
    if (!gisWindow) {
      toast.error("Please allow pop-ups for this site to open the GIS Dashboard.");
      return;
    }
    gisWindow.opener = null;
    try {
      const response = await fetchData("gis/launch", "POST", {}, {}, {}, navigate, null, dispatch);
      if (!response?.data?.url) throw new Error("No GIS address returned");
      gisWindow.location.href = response.data.url;
    } catch (error) {
      gisWindow.close();
      toast.error(error?.message || "Could not open the GIS Dashboard.");
    }
  };

  const handleItemClick = (id, isExternal = false) => {
    if (isExternal) {
      openGisDashboard();
      return;
    }
    setActiveItem(id);
    setOpenDropdown((prev) => (prev === id ? null : id));
    setActiveChild(null);
  };

  const handleChildClick = (parentId, childLink) => {
    setActiveItem(parentId);
    setActiveChild(childLink);
    setOpenDropdown(parentId);
  };

  const MiniSidebar = ({ menuItems, activeItem, setActiveItem }) => (
    <div className="w-16 fixed top-0 bg-primaryDark h-full shadow-md flex flex-col items-center">
      <img src={mobilelogo} alt="logo" className="w-14 py-[4px] px-1" />
      {menuItems.map((item) => {
        const IconComponent = item.icon;
        return (
          <button
            key={item.id}
            onClick={() => {
              if (item.isExternal) {
                openGisDashboard();
              } else {
                setActiveItem(item.id);
              }
            }}
            className={`my-2 p-[5px] rounded-md hover:bg-gray-200 ${
              activeItem === item.id ? "bg-gray-300" : ""
            }`}
          >
            <IconComponent className="w-[21px] h-[21px] text-white" />
          </button>
        );
      })}
    </div>
  );

  return (
    <div
      className="flex relative"
      onMouseEnter={() => setIsSidebarHovered(true)}
      onMouseLeave={() => setIsSidebarHovered(false)}
    >
      {!isSidebarHovered && (
        <div className="hidden lg:block z-[105]">
          <MiniSidebar
            menuItems={menuItems}
            activeItem={activeItem}
            setActiveItem={handleItemClick}
          />
        </div>
      )}
      <div
        className={`top-0 w-[250px] fixed h-full bg-primaryDark left-0 z-[110] transition-all duration-500 ease-in-out 
   ${
     visible || isSidebarHovered
       ? "opacity-100 translate-x-0 visible"
       : "w-0 opacity-0 -translate-x-full invisible"
   }
 `}
      >
        <div className="h-[4rem] flex items-center justify-center">
          <a href="/" className="header-logo flex items-center">
            {visible || isSidebarHovered ? (
              <img
                src={desktoplogo}
                alt="logo"
                className="w-[16rem] border-[#0e6f72] border-b-2 px-[1.45rem] py-2"
              />
            ) : (
              <img src={mobilelogo} alt="logo" className="w-16 p-1" />
            )}
          </a>
        </div>

        <div className="w-[250px] mt-2">
          <div className="h-screen px-0 pb-[80px] w-[250px] sidebar-scroll overflow-y-auto">
            <ul className="flex flex-col gap-1">
              {menuItems.map((item) => (
                <li
                  key={item.id}
                  className={`flex flex-col text-white ${
                    activeItem === item.id ? "bg-primaryDark" : "bg-darkGray"
                  }`}
                >
                  {!item.isDropdown ? (
                    item.isExternal ? (
                      <button
                        onClick={() =>
                          handleItemClick(item.id, true)
                        }
                        className="flex p-3 justify-between items-center text-[0.85rem] w-full text-left"
                      >
                        <span className="flex gap-2 items-center">
                          {React.createElement(item.icon, { size: 20 })}
                          {item.label}
                        </span>
                      </button>
                    ) : (
                      <Link
                        to={item.link}
                        className="flex p-3 justify-between items-center text-[0.85rem]"
                        onClick={() => handleItemClick(item.id)}
                      >
                        <span className="flex gap-2 items-center">
                          {React.createElement(item.icon, { size: 20 })}
                          {item.label}
                        </span>
                      </Link>
                    )
                  ) : (
                    <>
                      <div
                        className="flex justify-between items-center p-3 text-[0.85rem] cursor-pointer"
                        onClick={() => handleItemClick(item.id)}
                      >
                        <span className="flex gap-2 items-center">
                          {React.createElement(item.icon, { size: 20 })}
                          {item.label}
                        </span>
                        <ChevronDown size={12} />
                      </div>
                      <ul
                        className={`bg-black/10 overflow-hidden transition-[max-height] duration-300 ease-in-out pl-[2rem] ${
                          openDropdown === item.id
                            ? "max-h-[1000px]"
                            : "max-h-0"
                        }`}
                      >
                        {item.options.map((option, index) => (
                          <li key={index}>
                            <Link
                              onClick={(e) => {
                                e.stopPropagation();
                                handleChildClick(item.id, option.link);
                              }}
                              to={option.link}
                              className="p-2 mt-1 flex items-center gap-2 text-[0.78rem]"
                            >
                              {option.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MobileSideBar;
